import React, { memo } from "react";

import Typography from "../_ui/Typography/Typography";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="p-200 text-center">
            <Typography>All Content © Vergo UK Ltd {year}</Typography>
        </footer>
    );
};

export default memo(Footer);
